import { EmissionEstimationIcons } from '@lune-fe/lune-components-lib'
import { ReactNode } from 'react'

export const icons: Record<string, ReactNode> = {
    air: EmissionEstimationIcons.plane,
    sea: EmissionEstimationIcons.ship,
    logisticSite: EmissionEstimationIcons.warehouse,
    rail: EmissionEstimationIcons.train,
    road: EmissionEstimationIcons.truck,
    inlandWaterway: EmissionEstimationIcons.waterway,
    load: EmissionEstimationIcons.load,
    client: EmissionEstimationIcons.load,
}

export const formattedLabels: Record<string, string> = {
    air: 'Air',
    sea: 'Sea',
    logisticSite: 'Logistic Site',
    rail: 'Rail',
    road: 'Road',
    inlandWaterway: 'Inland Waterway',
    load: 'Load',
    client: 'Load',
}

export const getPercentage = (total: number, value: number): number => {
    return (value * 100) / total
}
